import { FormProvider, useForm } from "react-hook-form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import UnForm from "../../../../Components/Form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { IAgendamentosComunicadosRequest } from "../../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";

interface IFiltroAgendamentosComunicadosPorAudiencia {
    filtroInicial: IAgendamentosComunicadosRequest;
    filter: IAgendamentosComunicadosRequest | undefined;
    setFilter: (filter: IAgendamentosComunicadosRequest) => void;
    FILTRO_AGENDAMENTO_AUDIENCIA: string | null;
}

export default function FiltroAgendamentosComunicadosPorAudiencia(
    props: IFiltroAgendamentosComunicadosPorAudiencia
) {
    const FormMethods = useForm();
    const { reset } = FormMethods;

    const { filtroInicial, filter, setFilter, FILTRO_AGENDAMENTO_AUDIENCIA } =
        props;

    function handleFilterSubmit(formData: IAgendamentosComunicadosRequest) {
        const filterFormData = {
            ...formData,
        };
        setFilter(filterFormData);
        sessionStorage.setItem(
            "FILTRO_AGENDAMENTO_AUDIENCIA",
            JSON.stringify(filterFormData)
        );
    }

    return (
        <StickyToolbar active={!!FILTRO_AGENDAMENTO_AUDIENCIA}>
            <FormProvider {...FormMethods}>
                <UnForm handleSubmit={handleFilterSubmit} usingContext>
                    <UnForm.Input
                        name="DT_INICIAL"
                        label="Data Inicial"
                        type="date"
                        defaultValue={filter?.DT_INICIAL}
                    />
                    <UnForm.Input
                        name="DT_FIM"
                        label="Data Final"
                        type="date"
                        defaultValue={filter?.DT_FIM}
                    />

                    <UnForm.Select
                        name="FL_EXECUTADO"
                        label="Status"
                        defaultValue={
                            filter?.FL_EXECUTADO === undefined ||
                            filter?.FL_EXECUTADO === null
                                ? ""
                                : String(filter?.FL_EXECUTADO)
                        }
                    >
                        <option value=""></option>
                        <option value="1">Executados</option>
                        <option value="0">Não Executados</option>
                    </UnForm.Select>

                    <UnForm.LazySelect
                        controller={ListarUsuariosController}
                        getDS={(item) => item.DS_NOME}
                        getKeyValue={(item) => item.ID_USUARIO}
                        name="ID_USUARIO"
                        label="Responsável"
                    >
                        <option></option>
                    </UnForm.LazySelect>

                    <UnForm.Input
                        name="ID_AUDIENCIA"
                        label="Número da Audiência"
                        type="number"
                    />

                    <div>
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark mt-2"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                sessionStorage.removeItem(
                                    "FILTRO_AGENDAMENTO_AUDIENCIA"
                                );
                                reset(filtroInicial);
                            }}
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </StickyToolbar>
    );
}
